import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Cittadinanza, Comune, Contatto, DettaglioAnagrafica, Diagnosi, DiagnosiEScale, Intervento, Presenza, Prestazione, Regione, StatoCivile, StatoEstero } from 'src/app/model/Models';
import { ApiService } from 'src/app/services/api.service';
import { SessionService } from 'src/app/services/session.service';
import { ToastService } from 'src/app/services/toast.service';
import {firstValueFrom} from "rxjs";

@Component({
  templateUrl: './dettaglio-dati-in-ingresso.component.html',
  styleUrls: ['./dettaglio-dati-in-ingresso.component.css']
})
export class DettaglioDatiInIngressoComponent implements OnInit {

  id: string | null = '';
  statoAttuale: string | null = '';
  anno: number | null = 0;
  isNotDaValidare: boolean = false;

  isActiveAnagrafica: boolean = true;
  isActiveContatti: boolean = false;
  isActiveInterventi: boolean = false;
  isActiveDiagnosi: boolean = false;
  isActivePresenze: boolean = false;
  isActivePrestazioni: boolean = false;

  listStatiCivili: StatoCivile[] = [];
  dettaglioAnagrafica?: DettaglioAnagrafica | null
  listContatti: Contatto[] = [];
  listInterventi: Intervento[] = [];
  listDiagnosiEScale: DiagnosiEScale[] = [];
  listPresenze: Presenza[] = [];
  listPrestazione: Prestazione[] = [];
  private diagnosiDescrizioniByCodice: Map<string, string> | null = null;
  private diagnosiDescrizioniLoading?: Promise<void>;


  scartiContatti: {[key: number]: string} = {};
  scartiInterventi: {[key: number]: string} = {};
  scartiDiagnosi: {[key: number]: string} = {};
  scartiPresenze: {[key: number]: string} = {};
  scartiPrestazioni: {[key: number]: string} = {};

  validaContatti: number[] = [];
  validaInterventi: number[] = [];
  validaDiagnosi: number[] = [];
  validaPresenze: number[] = [];
  validaPrestazioni: number[] = [];

  notCheckedContatti: number[] = [];
  notCheckedInterventi: number[] = [];
  notCheckedDiagnosi: number[] = [];
  notCheckedPresenze: number[] = [];
  notCheckedPrestazioni: number[] = [];


  constructor( private route: ActivatedRoute, private router: Router,
    private toastService: ToastService,
    private apiService: ApiService ) { }

  ngOnInit(): void {

    this.id = this.route.snapshot.paramMap.get('id');
    this.statoAttuale = this.route.snapshot.paramMap.get('stato');
    this.anno = Number(this.route.snapshot.paramMap.get('anno'));

    this.init();
  }


  async getAllStatiCivili() {
    this.apiService.getAllStatiCivili().subscribe(res => {
      this.listStatiCivili = res
    })

  }

  async getAnagraficaContatto()
  {

    this.apiService.getAnagraficaAslValidator( this.id ).subscribe((data: any) => {
        // console.log(data);
        this.dettaglioAnagrafica = data;

      });

  }


  async getContattiUtente()
  {

    this.apiService.getContattiAslValidator( this.id, this.statoAttuale ).subscribe(async (data: any) => {
        // console.log(data);
        if(data != undefined || data!= null)
        {
          this.listContatti = data;
          await this.enrichContattiDiagnosiDescrizione(this.listContatti);

          data.forEach((value: { id: string; })=> {
            this.notCheckedContatti.push(Number(value.id));
          })
        }

      });

  }

  private getContattoRiferimento(): Contatto | null {
    if (this.listContatti && this.listContatti.length > 0) {
      return this.listContatti[0];
    }
    return null;
  }

  private sameDay(a: any, b: any): boolean {
    if (!a || !b) {
      return false;
    }
    const da = new Date(a);
    const db = new Date(b);
    if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) {
      return false;
    }
    return da.getFullYear() === db.getFullYear() && da.getMonth() === db.getMonth() && da.getDate() === db.getDate();
  }

  isDiagnosiAperturaContatto(diagnosi: DiagnosiEScale): boolean {
    const contatto = this.getContattoRiferimento();
    if (!contatto?.dataApertura) {
      return false;
    }
    return this.sameDay(diagnosi?.data, contatto.dataApertura);
  }

  isDiagnosiChiusuraContatto(diagnosi: DiagnosiEScale): boolean {
    const contatto = this.getContattoRiferimento();
    if (!contatto?.dataChiusura) {
      return false;
    }
    return this.sameDay(diagnosi?.data, contatto.dataChiusura);
  }

  // Modifiche MC 2025/05/07 aggiunta parametro anno
  async getInterventiUtente()
  {

    this.apiService.getInterventiAslValidator( this.id, this.statoAttuale, this.anno ).subscribe((data: any) => {
      // console.log("Interventi: ");
      // console.log(data);
        if(data != undefined || data!= null)
        {
          this.listInterventi = data;

          data.forEach((value: { id: string; })=> {
            console.log(data);
            this.notCheckedInterventi.push(Number(value.id));
          })
        }

      });

  }

  // Modifiche MC 2025/05/07 aggiunta parametro anno
  async getDiagnosiEScaleUtente()
  {

    this.apiService.getDiagnosiEScaleAslValidator( this.id, this.statoAttuale, this.anno ).subscribe(async (data: any) => {
        this.listDiagnosiEScale = data;
      // console.log(data);
        if(data != undefined || data!= null)
        {
          this.listDiagnosiEScale = data;
          await this.enrichDiagnosiEScaleDescrizione(this.listDiagnosiEScale);

          data.forEach((value: { id: string; })=> {
            this.notCheckedDiagnosi.push(Number(value.id));
          })
        }

      });

  }

  // Modifiche MC 2025/05/07 aggiunta parametro anno
  async getPresenzeUtente()
  {

    this.apiService.getPresenzeAslValidator( this.id, this.statoAttuale, this.anno ).subscribe((data: any) => {
      // console.log(data);
        if(data != undefined || data!= null)
        {
          this.listPresenze = data;

          data.forEach((value: { id: string; })=> {
            this.notCheckedPresenze.push(Number(value.id));
          })
        }

      });

  }

  // Modifiche MC 2025/05/07 aggiunta parametro anno
  async getPrestazioneUtente()
  {

    this.apiService.getPrestazioneAslValidator( this.id, this.statoAttuale, this.anno).subscribe((data: any) => {
      // console.log(data);
        if(data != undefined || data!= null)
        {
          console.log("dataaaa:"+ data)
          console.log(data);
          this.listPrestazione= data;

          data.forEach((value: { id: string; })=> {
            this.notCheckedPrestazioni.push(Number(value.id));
          })
        }

      });

  }


  onChangeValida( event: any , type: string ){
    if ( type=='contatti' )
    {
      if(event.target.checked)
      {

        delete this.scartiContatti[ Number(event.target.value) ];

        this.validaContatti.push(Number(event.target.value));

        if( this.notCheckedContatti.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedContatti.splice( this.notCheckedContatti.indexOf(Number(event.target.value)),1);

      }
      else if ( this.validaContatti.indexOf(Number(event.target.value)) != -1 )
      {
        this.validaContatti.splice( this.validaContatti.indexOf(Number(event.target.value)),1);

        this.notCheckedContatti.push(Number(event.target.value));
      }
    }

    if ( type=='interventi' )
    {
      if(event.target.checked)
      {

        delete this.scartiInterventi[ Number(event.target.value) ];

        this.validaInterventi.push(Number(event.target.value));

        if( this.notCheckedInterventi.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedInterventi.splice( this.notCheckedInterventi.indexOf(Number(event.target.value)),1);

      }
      else if ( this.validaInterventi.indexOf(Number(event.target.value)) != -1 )
      {
        this.validaInterventi.splice( this.validaInterventi.indexOf(Number(event.target.value)),1);

        this.notCheckedInterventi.push(Number(event.target.value));
      }
    }

    if ( type=='diagnosi' )
    {
      if(event.target.checked)
      {

        delete this.scartiDiagnosi[ Number(event.target.value) ];

        this.validaDiagnosi.push(Number(event.target.value));

        if( this.notCheckedDiagnosi.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedDiagnosi.splice( this.notCheckedDiagnosi.indexOf(Number(event.target.value)),1);

      }
      else if ( this.validaDiagnosi.indexOf(Number(event.target.value)) != -1 )
      {
        this.validaDiagnosi.splice( this.validaDiagnosi.indexOf(Number(event.target.value)),1);

        this.notCheckedDiagnosi.push(Number(event.target.value));
      }
    }

    if ( type=='presenze' )
    {
      if(event.target.checked)
      {

        delete this.scartiPresenze[ Number(event.target.value) ];

        this.validaPresenze.push(Number(event.target.value));

        if( this.notCheckedPresenze.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedPresenze.splice( this.notCheckedPresenze.indexOf(Number(event.target.value)),1);

      }
      else if ( this.validaPresenze.indexOf(Number(event.target.value)) != -1 )
      {
        this.validaPresenze.splice( this.validaPresenze.indexOf(Number(event.target.value)),1);

        this.notCheckedPresenze.push(Number(event.target.value));
      }
    }

    if ( type=='prestazioni' )
    {
      if(event.target.checked)
      {

        delete this.scartiPrestazioni[ Number(event.target.value) ];

        this.validaPrestazioni.push(Number(event.target.value));

        if( this.notCheckedPrestazioni.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedPrestazioni.splice( this.notCheckedPrestazioni.indexOf(Number(event.target.value)),1);

      }
      else if ( this.validaPrestazioni.indexOf(Number(event.target.value)) != -1 )
      {
        this.validaPrestazioni.splice( this.validaPrestazioni.indexOf(Number(event.target.value)),1);

        this.notCheckedPrestazioni.push(Number(event.target.value));
      }
    }
  }

  onChangeScarta(  event: any , type: string ){
    if ( type=='contatti' )
    {
      if(event.target.checked)
      {
        if( this.validaContatti.indexOf(Number(event.target.value)) != -1 )
          this.validaContatti.splice( this.validaContatti.indexOf(Number(event.target.value)),1);


        this.scartiContatti[Number(event.target.value)] = '';

        if( this.notCheckedContatti.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedContatti.splice( this.notCheckedContatti.indexOf(Number(event.target.value)),1);

      }
      else
      {
        delete this.scartiContatti[ Number(event.target.value) ];

        this.notCheckedContatti.push(Number(event.target.value));
      }
    }
    if ( type=='interventi' )
    {
      if(event.target.checked)
      {
        if( this.validaInterventi.indexOf(Number(event.target.value)) != -1 )
          this.validaInterventi.splice( this.validaInterventi.indexOf(Number(event.target.value)),1);

        this.scartiInterventi[Number(event.target.value)] = '';

        if( this.notCheckedInterventi.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedInterventi.splice( this.notCheckedInterventi.indexOf(Number(event.target.value)),1);

      }
      else
      {
        delete this.scartiInterventi[ Number(event.target.value) ];

        this.notCheckedInterventi.push(Number(event.target.value));

      }
    }
    if ( type=='diagnosi' )
    {
      if(event.target.checked)
      {
        if( this.validaDiagnosi.indexOf(Number(event.target.value)) != -1 )
          this.validaDiagnosi.splice( this.validaDiagnosi.indexOf(Number(event.target.value)),1);

        this.scartiDiagnosi[Number(event.target.value)] = '';

        if( this.notCheckedDiagnosi.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedDiagnosi.splice( this.notCheckedDiagnosi.indexOf(Number(event.target.value)),1);

      }
      else
      {
        delete this.scartiDiagnosi[ Number(event.target.value) ];

        this.notCheckedDiagnosi.push(Number(event.target.value));

      }
    }
    if ( type=='presenze' )
    {
      if(event.target.checked)
      {
        if( this.validaPresenze.indexOf(Number(event.target.value)) != -1 )
          this.validaPresenze.splice( this.validaPresenze.indexOf(Number(event.target.value)),1);

        this.scartiPresenze[Number(event.target.value)] = '';

        if( this.notCheckedPresenze.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedPresenze.splice( this.notCheckedPresenze.indexOf(Number(event.target.value)),1);

      }
      else
      {
        delete this.scartiPresenze[ Number(event.target.value) ];

        this.notCheckedPresenze.push(Number(event.target.value));

      }
    }
    if ( type=='prestazioni' )
    {
      if(event.target.checked)
      {
        if( this.validaPrestazioni.indexOf(Number(event.target.value)) != -1 )
          this.validaPrestazioni.splice( this.validaPrestazioni.indexOf(Number(event.target.value)),1);

        this.scartiPrestazioni[Number(event.target.value)] = '';

        if( this.notCheckedPrestazioni.indexOf(Number(event.target.value)) != -1 )
          this.notCheckedPrestazioni.splice( this.notCheckedPrestazioni.indexOf(Number(event.target.value)),1);

      }
      else
      {
        delete this.scartiPrestazioni[ Number(event.target.value) ];

        this.notCheckedPrestazioni.push(Number(event.target.value));

      }
    }

    console.log(this.scartiContatti )
  }



  isSelectedValidati(id: number | undefined, type: string) {
    let ret: boolean = false;
    if(type == 'contatti')
    {
      this.validaContatti.forEach(value => {
        if (value == id) {
          ret = true;
        }
      })
    }
    if(type == 'interventi')
    {
      this.validaInterventi.forEach(value => {
        if (value == id) {
          ret = true;
        }
      })
    }
    if(type == 'diagnosi')
    {
      this.validaDiagnosi.forEach(value => {
        if (value == id) {
          ret = true;
        }
      })
    }
    if(type == 'presenze')
    {
      this.validaPresenze.forEach(value => {
        if (value == id) {
          ret = true;
        }
      })
    }
    if(type == 'prestazioni')
    {
      this.validaPrestazioni.forEach(value => {
        if (value == id) {
          ret = true;
        }
      })
    }
    return ret;
  }


  isSelectedScartati(id: number | undefined, type: string) {
    let ret: boolean = false;
    if(type == 'contatti')
    {
      if(this.scartiContatti[Number(id)] != undefined)
        ret = true;
    }
    if(type == 'interventi')
    {
      if(this.scartiInterventi[Number(id)] != undefined)
        ret = true;
    }
    if(type == 'diagnosi')
    {
      if(this.scartiDiagnosi[Number(id)] != undefined)
        ret = true;
    }
    if(type == 'presenze')
    {
      if(this.scartiPresenze[Number(id)] != undefined)
        ret = true;
    }
    if(type == 'prestazioni')
    {
      if(this.scartiPrestazioni[Number(id)] != undefined)
        ret = true;
    }
    return ret;
  }

  changeMotivazioniScarto(id: number | undefined, type: string, event: any  )
  {

    if(type == 'contatti')
    {
      this.scartiContatti[Number(id)] = event.target.value;
    }
    if(type == 'interventi')
    {
      this.scartiInterventi[Number(id)] = event.target.value;
    }
    if(type == 'diagnosi')
    {
      this.scartiDiagnosi[Number(id)] = event.target.value;
    }
    if(type == 'presenze')
    {
      this.scartiPresenze[Number(id)] = event.target.value;   true;
    }
    if(type == 'prestazioni')
    {
      this.scartiPrestazioni[Number(id)] = event.target.value;   true;
    }

  }

  checkContattiIsToValidate( contatti: Contatto[])
  {

    var toValidate = false;
    contatti.forEach(contatto => {
      if(contatto.statoAttuale.id == 2)
        toValidate = true
    });

    return toValidate
  }

  salvaTutto()
  {

    var emptyMotivation = false;
    for (const k in this.scartiContatti )
      if( this.scartiContatti[Number(k)] == undefined ||  this.scartiContatti[Number(k)] == null || this.scartiContatti[Number(k)].length == 0)
        emptyMotivation = true;

    for (const k in this.scartiInterventi )
      if( this.scartiInterventi[Number(k)] == undefined ||  this.scartiInterventi[Number(k)] == null || this.scartiInterventi[Number(k)].length == 0)
        emptyMotivation = true;

    for (const k in this.scartiDiagnosi )
      if( this.scartiDiagnosi[Number(k)] == undefined ||  this.scartiDiagnosi[Number(k)] == null || this.scartiDiagnosi[Number(k)].length == 0)
        emptyMotivation = true;

    for (const k in this.scartiPresenze )
      if( this.scartiPresenze[Number(k)] == undefined ||  this.scartiPresenze[Number(k)] == null || this.scartiPresenze[Number(k)].length == 0)
        emptyMotivation = true;

    for (const k in this.scartiPrestazioni )
      if( this.scartiPrestazioni[Number(k)] == undefined ||  this.scartiPrestazioni[Number(k)] == null || this.scartiPrestazioni[Number(k)].length == 0)
        emptyMotivation = true;



    if( emptyMotivation )
    {
      alert("Inserire la motivazione dello scarto!");
    }
    else if(this.notCheckedContatti.length > 0 && this.checkContattiIsToValidate(this.listContatti) )
    {
      alert("è obbligatorio Validare o Scartare tutti i Contatti!");
    }
    else if(this.notCheckedInterventi.length > 0)
    {
      alert("è obbligatorio Validare o Scartare tutti gli Interventi!");
    }
    else if(this.notCheckedDiagnosi.length > 0)
    {
      alert("è obbligatorio Validare o Scartare tutte le Diagnosi!");
    }
    else if(this.notCheckedPresenze.length > 0)
    {
      alert("è obbligatorio Validare o Scartare tutte le Presenze!");
    }
    else if(this.notCheckedPrestazioni.length > 0)
    {
      alert("è obbligatorio Validare o Scartare tutte le Prestazioni!");
    }
    else
    {


      if( this.validaContatti.length > 0)
        this.apiService.updateStatusContatti(3, '', this.validaContatti ).subscribe();


      if( this.validaInterventi.length > 0)
        this.validaInterventi.forEach(value => {
          this.apiService.updateStatusIntervento(value, 3, '' ).subscribe();
        })


      if( this.validaDiagnosi.length > 0)
        this.validaDiagnosi.forEach(value => {
          this.apiService.updateStatusDiagnosi(value, 3, '' ).subscribe();
        })

      if( this.validaPresenze.length > 0)
        this.validaPresenze.forEach(value => {
          this.apiService.updateStatusPresenza(value, 3, '' ).subscribe();
        })

      if( this.validaPrestazioni.length > 0)
        this.validaPrestazioni.forEach(value => {
          this.apiService.updateStatusPrestazione(value, 3, '' ).subscribe();
        })

      for (const k in this.scartiContatti )
      {
        var listId: number[] = [];
        listId.push(Number(k));
        this.apiService.updateStatusContatti(4, this.scartiContatti [Number(k)], listId).subscribe();
      }


      for (const k in this.scartiInterventi )
        this.apiService.updateStatusIntervento( Number(k), 4, this.scartiInterventi[Number(k)] ).subscribe();

      for (const k in this.scartiDiagnosi )
        this.apiService.updateStatusDiagnosi( Number(k), 4, this.scartiDiagnosi[Number(k)] ).subscribe();

      for (const k in this.scartiPresenze )
        this.apiService.updateStatusPresenza( Number(k), 4, this.scartiPresenze[Number(k)] ).subscribe();

      for (const k in this.scartiPrestazioni )
        this.apiService.updateStatusPrestazione( Number(k), 4, this.scartiPrestazioni[Number(k)] ).subscribe();

      this.toastService.showSuccess("Processo di validazione effettuata con successo!");

      this.router.navigate(['dati-in-ingresso']);
      return true;
    }

    return true;

  }

  chiudi()
  {
    this.router.navigate(['dati-in-ingresso']);
  }

  async riabilitaModifica(id: number|undefined, tipo: string) {
      await firstValueFrom(this.apiService.riabilitaModifica(id!,tipo));
      this.init();
  }

  private async ensureDiagnosiDescrizioniByCodice(): Promise<void> {
    if (this.diagnosiDescrizioniByCodice) {
      return;
    }
    if (this.diagnosiDescrizioniLoading) {
      await this.diagnosiDescrizioniLoading;
      return;
    }

    this.diagnosiDescrizioniLoading = (async () => {
      try {
        const diagnosiList = await firstValueFrom(this.apiService.getAllDiagnosi());
        const map = new Map<string, string>();
        (diagnosiList ?? []).forEach((diag: Diagnosi) => {
          const codice = this.normalizeDiagnosiCodice(diag?.codice);
          const codiceLoose = this.normalizeDiagnosiCodiceLoose(diag?.codice);
          const descrizione = (diag?.descrizione ?? '').toString().trim();
          if (codice && descrizione) {
            map.set(codice, descrizione);
            if (codiceLoose) {
              map.set(codiceLoose, descrizione);
            }
          }
        });
        this.diagnosiDescrizioniByCodice = map;
      } catch {
        this.diagnosiDescrizioniByCodice = new Map<string, string>();
      }
    })();

    await this.diagnosiDescrizioniLoading;
    this.diagnosiDescrizioniLoading = undefined;
  }

  private normalizeDiagnosiCodice(codice: string | undefined): string {
    return (codice ?? '').toString().trim().toUpperCase();
  }

  private normalizeDiagnosiCodiceLoose(codice: string | undefined): string {
    return this.normalizeDiagnosiCodice(codice).replace(/[^A-Z0-9]/g, '');
  }

  private lookupDiagnosiDescrizione(codice: string | undefined): string {
    const key = this.normalizeDiagnosiCodice(codice);
    const keyLoose = this.normalizeDiagnosiCodiceLoose(codice);
    if ((!key && !keyLoose) || !this.diagnosiDescrizioniByCodice) {
      return '';
    }
    return this.diagnosiDescrizioniByCodice.get(key)
      ?? this.diagnosiDescrizioniByCodice.get(keyLoose)
      ?? '';
  }

  private getDiagnosiDescrizioneFromData(diagnosi: DiagnosiEScale | any): string {
    return (
      (diagnosi?.descrizioneDiagnosi ??
        diagnosi?.descrizione ??
        diagnosi?.diagnosiDescrizione ??
        '')
        .toString()
        .trim()
    );
  }

  /**
   * [ADEGUAMENTO-ICD10]
   * @param value
   * @returns
   */
  private normalizeNullableDisplay(value: any): string {
    const normalized = (value ?? '').toString().trim();
    if (!normalized || normalized.toLowerCase() === 'null' || normalized.toLowerCase() === 'undefined') {
      return '';
    }
    return normalized;
  }

  getDiagnosiIcd9Display(diagnosi: DiagnosiEScale | any): string {
    const codice = (diagnosi?.diagnosi ?? '').toString().trim();
    const descrizioneDiretta = this.getDiagnosiDescrizioneFromData(diagnosi);
    const descrizione = descrizioneDiretta || this.lookupDiagnosiDescrizione(codice);
    return `${codice ? codice + ' - ' : ''}${descrizione || ''}`;
  }

  /**
   * [ADEGUAMENTO-ICD10]
   * @param value
   * @returns
  */
  getDiagnosiIcd10Display(data: any, codiceField: string, descrizioneField: string): string {
    const codice = this.normalizeNullableDisplay(data?.[codiceField]);
    const descrizione = this.normalizeNullableDisplay(data?.[descrizioneField]);
    if (!codice && !descrizione) {
      return '';
    }
    return `${codice ? codice + ' - ' : ''}${descrizione}`;
  }

  private async enrichContattiDiagnosiDescrizione(contatti: Contatto[]): Promise<void> {
    if (!contatti?.length) {
      return;
    }

    const hasMissing = contatti.some(contatto =>
      ((contatto?.codiceDiagnosiApertura ?? '').toString().trim() && !(contatto?.descrizioneDiagnosiApertura ?? '').toString().trim()) ||
      ((contatto?.codiceDiagnosiChiusura ?? '').toString().trim() && !(contatto?.descrizioneDiagnosiChiusura ?? '').toString().trim())
    );

    if (!hasMissing) {
      return;
    }

    await this.ensureDiagnosiDescrizioniByCodice();

    contatti.forEach((contatto) => {
      const codiceApertura = (contatto?.codiceDiagnosiApertura ?? '').toString().trim();
      const descrApertura = (contatto?.descrizioneDiagnosiApertura ?? '').toString().trim();
      if (codiceApertura && !descrApertura) {
        contatto.descrizioneDiagnosiApertura = this.lookupDiagnosiDescrizione(codiceApertura);
      }

      const codiceChiusura = (contatto?.codiceDiagnosiChiusura ?? '').toString().trim();
      const descrChiusura = (contatto?.descrizioneDiagnosiChiusura ?? '').toString().trim();
      if (codiceChiusura && !descrChiusura) {
        contatto.descrizioneDiagnosiChiusura = this.lookupDiagnosiDescrizione(codiceChiusura);
      }
    });
  }

  private async enrichDiagnosiEScaleDescrizione(list: DiagnosiEScale[]): Promise<void> {
    if (!list?.length) {
      return;
    }

    const hasMissing = list.some(diagnosi =>
      (diagnosi?.diagnosi ?? '').toString().trim() &&
      !(diagnosi?.descrizioneDiagnosi ?? '').toString().trim()
    );

    if (!hasMissing) {
      return;
    }

    await this.ensureDiagnosiDescrizioniByCodice();

    list.forEach((diagnosi) => {
      const codice = (diagnosi?.diagnosi ?? '').toString().trim();
      const descrizione = this.getDiagnosiDescrizioneFromData(diagnosi);
      if (codice && !descrizione) {
        diagnosi.descrizioneDiagnosi = this.lookupDiagnosiDescrizione(codice);
      } else if (descrizione && !(diagnosi?.descrizioneDiagnosi ?? '').toString().trim()) {
        diagnosi.descrizioneDiagnosi = descrizione;
      }
    });
  }

  private init() {
    this.getAnagraficaContatto();

    this.getContattiUtente();

    this.getInterventiUtente();

    this.getDiagnosiEScaleUtente();

    this.getPresenzeUtente();

    this.getPrestazioneUtente();
  }
}
